<template>
    <BaseModal ref="mngBaseModalRef" v-bind="childProps">
        <template v-slot:body>
            <div class="search-wrap" >
                <div class="row">
                <div class="col-md-3">
                    <div class="mb-3">
                        <ElLabel name="회사명">
                            <template #end="{id}">
                                <ElInput :id="id" v-model="state.searchParams.cmp_nm" @inputKeyupEnter="getMngList"/>
                            </template>
                        </ElLabel>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <ElLabel name="사업부명">
                            <template #end="{id}">
                                <ElInput :id="id" v-model="state.searchParams.cmp_dvsn_nm" @inputKeyupEnter="getMngList"/>
                            </template>
                        </ElLabel>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <ElLabel name="이름">
                            <template #end="{id}">
                                <ElInput :id="id" v-model="state.searchParams.mngr_nm" @inputKeyupEnter="getMngList"/>
                            </template>
                        </ElLabel>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <ElLabel name="사업자번호">
                            <template #end="{id}">
                                <!-- <ElInput :id="id" v-model="state.searchParams.business_no" @inputKeyupEnter="getMngList"/> -->
                                <ElInput :id="id"
                                ref="businessNoRef"
                                @update:modelValue="r=>bizNoFormat(r)"
                                @inputKeyupEnter="getMngList"/>
                            </template>
                        </ElLabel>
                    </div>
                </div>                      
                </div>
            </div>


            <div class="search-detail-wrap"></div>

            <div class="text-end py-2">
                <ElButton type="search" @buttonClick="getMngList()">검색</ElButton>
            </div>

            <div class="table-responsive table-list">
                <DataTable  
                    v-model:selection="state.selectedRow" 
                    :value="state.gridRowData"   
                    selectionMode="single"
                    dataKey="mng_seq"
                    paginator 
                    :rows="20" 
                    :rowsPerPageOptions="[10, 20, 50, 100,200]" 
                    @row-dblclick="rowDbClick"
                    >
                    <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
                    <Column 
                    v-for="manager of state.gridColumn" 
                    :key="manager.mng_seq" 
                    :field="manager.field" 
                    :header="manager.headerName" 
                    sortable 
                    :style="manager.style"
                    >
                        <template #body="{ data,field }"  >
                            <template v-if="manager.field == 'mobile'">{{ getMobileMask(data.mobile) }}</template>
                            <template v-else>
                                {{ data[field] }}
                            </template>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </template>
    </BaseModal>

</template>

<script setup>
import { reactive,ref,onBeforeMount, watch } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import BaseModal from './BaseModal.vue';
import common from '@/js/common';
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { mngList,mngSelect } from '@/api/mng';
import { router } from '@/router';
import { useUserStore } from '@/store/user';
const userStore = useUserStore()
const emits = defineEmits(['return'])

const closeModal = ref()
const openModalBtnRef = ref()
const mngBaseModalRef = ref()
const businessNoRef = ref()
const childProps = ref({
    modalId : 'manager',
    modalNm : '담당자 조회',
    size : 'lg',
    btnList : [
        {name : '선택',classNm : 'modelFooterConfirm', function:selectMng},
    ]
})

const props = defineProps({
    callPage : {
        default : 'cp',
        type : String
    },
    mng_seq : {
        default : null,
        type : Number
    }
})


watch(
  () => props.mng_seq,
  (newVal,oldVal) => {
    mngDetail()
  }
)
onBeforeMount(async()=>{
    state.callPage = props.callPage
    if(userStore.user.authGrpId === 'ADMIN'){
        childProps.value.btnList.push({name : '담당자 추가',classNm : 'modelFooterConfirm', function:moveToPage})
    }
})



const state = reactive({

    gridColumn :[
        { headerName: '회사명' , field: "cmp_nm",checkboxSelection: true,style:{minWidth: '200px',maxWidth: '200px',textOverflow: 'ellipsis',overflow: 'hidden',whiteSpace: 'nowrap'}},
        { headerName: '사업부명' ,field: "cmp_dvsn_nm",  cellDataType: 'text',style:{minWidth: '200px',maxWidth: '200px',textOverflow: 'ellipsis',overflow: 'hidden',whiteSpace: 'nowrap'}},
        { headerName: '이름' ,field: "mngr_nm", cellDataType: 'text',style:{minWidth: '100px',maxWidth: '100px',textOverflow: 'ellipsis',overflow: 'hidden',whiteSpace: 'nowrap'}},
        { headerName: '직급' ,field: "postion", cellDataType: 'text',style:{minWidth: '100px',maxWidth: '100px',textOverflow: 'ellipsis',overflow: 'hidden',whiteSpace: 'nowrap'}},
        { headerName: '부서' ,field: "depart_nm", cellDataType: 'text',style:{minWidth: '100px',maxWidth: '100px',textOverflow: 'ellipsis',overflow: 'hidden',whiteSpace: 'nowrap'}},
        { headerName: '휴대폰번호' ,field: "mobile", cellDataType: 'text',style:{minWidth: '200px',maxWidth: '200px',textOverflow: 'ellipsis',overflow: 'hidden',whiteSpace: 'nowrap'}},
        { headerName: '이메일' ,field: "email", cellDataType: 'text',style:{minWidth: '200px',maxWidth: '200px',textOverflow: 'ellipsis',overflow: 'hidden',whiteSpace: 'nowrap'}},
        
    ],    
    gridRowData :[],
    selectedRow :[],
    searchParams: {
        cmp_nm : '',
        cmp_dvsn_nm : '',
        mngr_nm : '',
        business_no: '',
        page_count : 1,
        unit_count : 100000,
    }
})

//모바일 형식  (010-0000-0000)  
const getMobileMask = (mobile) => {

return common.phoneFormat(mobile)

}

async function getMngList(){
    try {
        setIsLoading(true)
        const res = await mngList(state.searchParams)
        state.gridRowData = res.rtn
    } catch (err) {
        console.error('api error',error)
        alert('매니저 조회 실패')
    } finally {
        setIsLoading(false)
    }

}

function selectMng(){
    let manager = state.selectedRow
    if(manager != null && closeModal != undefined && closeModal != ''){
        emits('return',manager)
        openModal()
    }else{
        alert('선택된 매니저가 없습니다.')
    }
}

function rowDbClick(row){
    emits('return',row.data)
    openModal()
}

async function mngDetail(){
    try {
        setIsLoading(true)
        const res = await mngSelect({mng_seq : props.mng_seq})
        emits('return',res.rtn)
    } catch (err) {
        console.error('api error',error)
        alert('매니저 조회 실패')
    } finally {
        setIsLoading(false)
    }
}

function moveToPage(){
    if(!confirm('담당자등록으로 나가시겠습니까')) return
    mngBaseModalRef.value.openModal()
    router.push('/sh/MSH_SR_001')
}

function openModal(){
    mngBaseModalRef.value.openModal()
}

//사업자번호 형식 체크
const bizNoFormat = (no) => {
    no = common.bizNoFormat(no);
    state.searchParams.business_no = no
    businessNoRef.value.input.value = state.searchParams.business_no
};

defineExpose({
    openModal
})
</script>